import { Input } from "@/components/ui/input";
import { CopyButton } from "@/components/ui/copy-button";

export function CopyField({
  className,
  label,
  value,
  id,
}: {
  className?: string;
  label: string;
  value?: string;
  id: string;
}) {
  return (
    <div className={className}>
      <h3 className="text-muted-foreground mb-1 text-xs">{label}</h3>
      <div className="flex flex-row items-center bg-muted dark:bg-sidebar rounded-md">
        <Input
          className="w-full border-none rounded-r-none shadow-none font-mono md:text-xs h-8 bg-transparent"
          placeholder={id}
          value={value}
          readOnly
        />
        <CopyButton
          buttonText=""
          className="rounded-l-none border-none size-8 [&_svg]:size-3.5 bg-transparent hover:bg-muted-foreground/10"
          tooltipText="Copy"
          textToCopy={value || ""}
          variant="outline"
          tooltipDelay={750}
        />
      </div>
    </div>
  );
}
